import { ADMIN_ROLE, CLIENT_ROLE } from '../consts/roles';

export const isAdmin = (roles) => {
  return roles.some((role) => role === ADMIN_ROLE);
};

export const isClient = (roles) => {
  return roles.some((role) => role === CLIENT_ROLE);
};
